var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('button',{staticClass:"close",class:{ 'close-inverse': _vm.inverse },on:{"click":_vm.closeModal}},[_c('Icon',{attrs:{"icon":"close","color":"white"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }